/** Display label for `deduction.custom_deduction_method` in tables and file-import UI. */
export function format_custom_deduction_method_label(value: string | null | undefined): string {
  if (value == null || value.trim() === "") {
    return "—"
  }
  const v = value.trim()
  const lower = v.toLowerCase()
  if (v === "DEDUCT" || lower === "deducted" || lower === "deduct") {
    return "Deducted off check"
  }
  if (
    v === "Pay Customer Directly" ||
    lower === "paid directly" ||
    lower === "pay customer directly" ||
    lower === "check request"
  ) {
    return "Check request"
  }
  return v
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe("format_custom_deduction_method_label", () => {
    it("maps canonical and legacy AI import values", () => {
      expect(format_custom_deduction_method_label("DEDUCT")).toBe("Deducted off check")
      expect(format_custom_deduction_method_label("Pay Customer Directly")).toBe("Check request")
      expect(format_custom_deduction_method_label("paid directly")).toBe("Check request")
      expect(format_custom_deduction_method_label("deducted")).toBe("Deducted off check")
    })
    it("returns em dash for empty", () => {
      expect(format_custom_deduction_method_label(null)).toBe("—")
      expect(format_custom_deduction_method_label("")).toBe("—")
      expect(format_custom_deduction_method_label("  ")).toBe("—")
    })
    it("passes through legacy strings", () => {
      expect(format_custom_deduction_method_label("Pay via AB")).toBe("Pay via AB")
    })
  })
}
